import { render, staticRenderFns } from "./TruformeEnd.vue?vue&type=template&id=3331d652"
import script from "./TruformeEnd.vue?vue&type=script&lang=js"
export * from "./TruformeEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports